module.exports = __webpack_public_path__ + "img/cgoldmine64_ua.d2e6099c.webp";